import "sweetalert";
import "#lib/assert.js";
import { IN_PLACE_SAVE_EVENT } from "#/admin/page_builder/in-place-save";

// Allow publishing control buttons to control the form without actually needing to be inside it
(function () {
  var syncStateInput = jQuery('<input name="sync_action" type="hidden" />');
  var previewInput = jQuery('<input name="dry_run" type="hidden" value="true"/>');
  var formSelector = "[data-behaviour~=primary-form]";
  var asserter = new Asserter();

  // BEHAVIOUR

  resetAllForms();
  jQuery(document).on("click", "[data-behaviour~=form-publishing-control]", handleClick);
  jQuery(window).on("pageshow", resetAllForms);

  // EVENT HANDLERS

  function handleClick(event) {
    event.preventDefault();

    var $button = jQuery(this);
    var returnTo = returnToForControl($button);
    var $form = asserter.element(formSelector, { limit: 1 });
    var message = $button.data("confirmation-message") || $form.data("confirmation-message");

    if ($form.data("submitting")) {
      return;
    }

    var previewURLField = $form.find("[name=preview_url]");

    // If the link we clicked defined a return_to, use that instead of what the form said
    if (returnTo) {
      $form.append(jQuery("<input>", { type: "hidden", name: "return_to", value: returnTo }));
    }

    if (previewURLField.length != 0) {
      var previewUrl = new URL(previewURLField.val(), window.location.origin);
      previewUrl.searchParams.set("page_builder", false);
      previewURLField.val(previewUrl);
    }

    if ($button.is("[data-qa-request]")) {
      submitFormWithQaRequest($form, $button, $button.data("qa-request"));
    } else if ($button.is("[data-sync-action]")) {
      submitFormWithSyncState($form, $button, $button.data("sync-action"), message);
    } else if ($button.data("preview")) {
      submitFormForPreview($form, $button, $button.attr("target"));
    } else {
      submitForm($form, $button);
    }
  }

  // HELPER FUNCTIONS

  function returnToForControl($control) {
    var href = $control.attr("href");

    return href ? new URL(href, window.location.href).searchParams.get("return_to") : null;
  }

  function defaultConfirmationMessage($form, syncState) {
    // Don't use the word 'copy' in confirm since it isn't user friendly
    if (syncState === "copy") {
      syncState = "publish";
    }

    return "Are you sure you want to " + syncState + " this content?";
  }

  function submitFormWithSyncState($form, $button, syncState, message) {
    swal(
      {
        title: "Please Confirm",
        text: message || defaultConfirmationMessage($form, syncState),
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#5aadca",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      function () {
        if ($form.length) {
          syncStateInput.val(syncState);
          submitModifiedForm($form, $button, syncStateInput);
        } else {
          console.error("Couldn't find form to submit");
        }
      },
    );
    tagConfirmButton($button);
  }

  // The dialog is library-built and its DOM is reused between opens, so the
  // confirm button's testid is set or cleared on every open from the
  // triggering control's data-confirm-testid (value from the test-id catalog).
  function tagConfirmButton($button) {
    jQuery(".sweet-alert button.confirm").attr("data-testid", $button.data("confirm-testid") || null);
  }

  function submitFormWithQaRequest(form, $button, qaRequest) {
    submitModifiedForm(
      form,
      $button,
      jQuery('<input name="' + qaRequest + '[qa_requested]" value="true" type="hidden" />'),
    );
  }

  function submitFormForPreview(form, $button, target) {
    submitModifiedForm(form, $button, [previewInput], { target: target });
  }

  function submitModifiedForm($form, $button, inputs, attributes) {
    attributes = attributes || {};

    var oldAttributes = {};
    jQuery.each(attributes, function (key, value) {
      oldAttributes[key] = $form.attr(key) || null;
    });

    $form.attr(attributes);
    $form.append(inputs);

    if (submitForm($form, $button) && attributes.target && attributes.target != "_self") {
      resetFormSubmissionState($form);
    }

    jQuery.each(inputs, function (index, input) {
      jQuery(input).detach();
    });
    $form.attr(oldAttributes);
  }

  function submitForm($form, $button) {
    if ($form.data("submitting")) {
      return false;
    }

    $form.data("submitting", true);
    $form.data("submit-button", $button);

    const remote = $form.is("[data-remote=true]");

    if (remote) {
      // Remote saves keep this page open, so reset the Save button when that request finishes.
      resetFormSubmissionStateOnAjaxComplete($form);
    }

    if ($button) {
      var originalHtml = $button.data("original-html") || $button.html();
      $button.data("original-html", originalHtml);
      $button.prop("disabled", true);
      $button.html(originalHtml.replace("Save", "Saving..."));
    }

    // A submit the browser does not carry out leaves the page in place, and the `submitting`
    // latch above would then refuse every later Save.
    const form = $form[0];
    let submitEvent = null;
    let inPlaceSave = null;

    function observeSubmit(event) {
      submitEvent = event;
    }

    function observeInPlaceSave(event) {
      inPlaceSave = event.detail.saving;
    }

    if (form) {
      form.addEventListener("submit", observeSubmit);
      form.addEventListener(IN_PLACE_SAVE_EVENT, observeInPlaceSave);
    }

    var fallbackSubmit = jQuery('<input type="submit">').appendTo($form); // Append a submit in case it doesn't have one
    $form.find('[type="submit"]:not([data-behavior="nested-form-submit"])').first().trigger("click"); // Submit form with a submit click to trigger HTML5 validation UI
    fallbackSubmit.remove();

    if (form) {
      form.removeEventListener("submit", observeSubmit);
      form.removeEventListener(IN_PLACE_SAVE_EVENT, observeInPlaceSave);
    }

    // A save that keeps the page open holds the button's saving state until it settles.
    if (inPlaceSave) {
      inPlaceSave.finally(function resetWhenSettled() {
        resetFormSubmissionState($form);
      });

      return true;
    }

    // Read after the dispatch rather than inside the listener: delegated handlers on ancestors
    // run later in the bubble, so the event is only final once the click has returned.
    // A submit the browser refuses dispatches no event at all, so the attempt never started.
    // A remote save does dispatch one and then has it cancelled by the AJAX lifecycle, which
    // starts the request and owns the reset from `ajax:complete`.
    const submitted = submitEvent !== null && (remote || !submitEvent.defaultPrevented);

    if (!submitted) {
      resetFormSubmissionState($form);

      return false;
    }

    return true;
  }

  function resetFormSubmissionStateOnAjaxComplete($form) {
    $form.off("ajax:complete.formPublishingControl");

    function resetAfterRemoteSave() {
      resetFormSubmissionState($form);
    }

    $form.one("ajax:complete.formPublishingControl", resetAfterRemoteSave);
  }

  function resetAllForms() {
    jQuery(formSelector).each(function () {
      resetFormSubmissionState(jQuery(this));
    });
  }

  function resetFormSubmissionState($form) {
    $form.removeData("submitting");

    var $button = $form.data("submit-button");

    if ($button && $button.length) {
      $button.prop("disabled", false);

      if ($button.data("original-html")) {
        $button.html($button.data("original-html"));
        $button.removeData("original-html");
      }
    }

    $form.removeData("submit-button");
  }
})();
